var finansudd = finansudd || {};

finansudd.footer = new function(){

    var self = this;


    this.toggleList = function (selector) {

		$(selector).click(function() {
			$(this).toggleClass('active');
		});

	};

};